import { slLanguageInterceptor } from '@screenleads/i18n';
import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { FIREBASE_AUTH } from './core/services/firebase-auth.token';

import { routes } from './app.routes';
import { authInterceptor, errorInterceptor } from './core/interceptors';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withXhr(), 
      withInterceptors([slLanguageInterceptor,authInterceptor, errorInterceptor])
    ),
    { provide: FIREBASE_AUTH, useFactory: () => getAuth(getApps().length ? getApp() : initializeApp(environment.firebase)) },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode() && location.hostname !== 'localhost',
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
